<template>
  <IdentifierResults
    v-slot="{ identifierResult }"
    :max-items-to-render="5"
    :animation="animation"
    class="x-flex x-flex-col x-gap-8 desktop:x-col-span-12 desktop:x-gap-4"
  >
    <BaseResultLink
      v-slot="{ result }"
      :result="identifierResult"
      class="x-suggestion x-suggestion-lg desktop:x-suggestion-md"
    >
      <BarCodeIcon class="x-icon-lg desktop:x-icon-md" />
      <IdentifierResult :result="result" />
      <span>
        {{ result.name }}
      </span>
    </BaseResultLink>
  </IdentifierResults>
</template>

<script setup lang="ts">
import type { AnimationProp } from '@empathyco/x-components'
import { BarCodeIcon, BaseResultLink } from '@empathyco/x-components'
import { IdentifierResult, IdentifierResults } from '@empathyco/x-components/identifier-results'

defineProps<{
  animation: typeof AnimationProp
}>()
</script>
<style lang="scss"></style>
